var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoon = function SvgMoon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M24.048 8a16.1 16.1 0 0 0-8.25 2.276 16 16 0 0 0-5.901 6.18 15.96 15.96 0 0 0 .803 16.426 16.04 16.04 0 0 0 6.478 5.577A16.1 16.1 0 0 0 33.6 36.861a16 16 0 0 0 5.273-6.72c.548-1.312-.764-2.63-2.083-2.096a10.46 10.46 0 0 1-7.096.266 10.43 10.43 0 0 1-5.623-4.322 10.374 10.374 0 0 1 1.702-13.203l.123-.128c.885-1.008.182-2.645-1.216-2.645h-.427l-.11-.01z"
  })));
};
export default SvgMoon;